import React from "react";

const Heading = ({
  children = null,
  className,
  level = 2,
  size: fontSize = "1.875rem",
  weight: fontWeight = "300"
}) => {
  const H = `h${level}`;
  return (
    <H className={className} style={{ fontSize, fontWeight }}>
      {children}
    </H>
  );
};

Heading.One = props => (
  <Heading level={1} size="2.25rem" weight="400" {...props} />
);
Heading.Two = props => (
  <Heading level={2} size="1.875rem" weight="300" {...props} />
);
Heading.Three = props => (
  <Heading level={3} size="1.5rem" weight="400" {...props} />
);
Heading.Four = props => (
  <Heading level={4} size="1.125rem" weight="700" {...props} />
);
Heading.Five = props => (
  <Heading level={5} size="0.875rem" weight="400" {...props} />
);
Heading.Six = props => (
  <Heading level={6} size="0.75rem" weight="700" {...props} />
);

export default Heading;
